import { render } from "./klb-list.vue?vue&type=template&id=94d83afe&scoped=true"
import script from "./klb-list.vue?vue&type=script&lang=js"
export * from "./klb-list.vue?vue&type=script&lang=js"

import "./klb-list.vue?vue&type=style&index=0&id=94d83afe&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d83afe"]])

export default __exports__